import { render } from "./branch-editable-tree-node.vue?vue&type=template&id=2afdab38"
import script from "./branch-editable-tree-node.vue?vue&type=script&lang=js"
export * from "./branch-editable-tree-node.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__